import { Component } from '@angular/core';

@Component({
    selector: 'fi-page-collapsable-content-subtitle',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FiPageCollapsableContentSubtitleComponent {}
